define.alias("ember-composable-helpers/helpers/pipe", "calendar/helpers/pipe");